module.exports = {"441704100":"东城镇","441704101":"北惯镇","441704102":"那龙镇","441704103":"东平镇","441704104":"雅韶镇","441704105":"大沟镇","441704106":"新洲镇","441704107":"合山镇","441704108":"塘坪镇","441704109":"大八镇","441704110":"红丰镇","441704400":"阳江监狱","441704401":"红五月农场","441704402":"鸡山农场","441704501":"阳江林场宝山分场","441704502":"阳江林场田畔分场","441704503":"阳东原种场","441704504":"阳东林场","441704505":"阳江林场东岸分场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441704.json
// module id = 2043
// module chunks = 0